import { render, staticRenderFns } from "./TicketDetailPage.vue?vue&type=template&id=34210c97&"
import script from "./TicketDetailPage.vue?vue&type=script&lang=js&"
export * from "./TicketDetailPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/cjzhi98/chatwoot-saas/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('34210c97')) {
      api.createRecord('34210c97', component.options)
    } else {
      api.reload('34210c97', component.options)
    }
    module.hot.accept("./TicketDetailPage.vue?vue&type=template&id=34210c97&", function () {
      api.rerender('34210c97', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/routes/dashboard/coLiving/TicketDetailPage.vue"
export default component.exports